import React from 'react'
import { Container, Row } from 'react-bootstrap'
import SideProfile from './side'
import Overview from './overview'
import { Link, useLocation } from "react-router-dom";

interface Profile {
  data: any,
}


const ContractorProfile = () => {
  const location = useLocation();
  const profileData = location.state.data;
  //console.log(profileData, "profileData")

  document.title=" Profile | Steex - Admin & Dashboard Template"

  return (
    <React.Fragment>
        <div className="page-content">
            <Container fluid>
                <Row>
                    <SideProfile data={profileData} />
                    <Overview data={profileData} />
                </Row>
            </Container>
        </div>
    </React.Fragment>
  );
};

export default ContractorProfile